import * as React from 'react';
import DetailsBtn from "../../Details/Details";
import * as styles from './CarouselItem.module.scss';

const CarouselItem = ({ title1, title2, subtitle1, subtitle2, description, img, detailsText, detailsPath, slides, click, selected, color, smallImg }) => (
  <div className={styles.infoContainer}>
    {img &&
    <div className={smallImg ? styles.imageContainerSmall : styles.imageContainer}>
      <img className={smallImg ? styles.bgImgSmall : styles.bgImg} alt='Flatfy carousel' src={img}/>
    </div>
    }
    <div className={styles.slideContainer}>
      <div className={styles.slide}>
        <div className={styles.subtitle} style={{ color: color }}>
          <div>{subtitle1}</div>
          {subtitle2 && <div>{subtitle2}</div>}
        </div>
        <div className={styles.container}>
          <div className={styles.titleBlock}>
            <div className={styles.title} style={{ color: color }}>
              {title1}
            </div>
            {title2 &&
            <div className={styles.title} style={{ color: color }}>
              {title2}
            </div>
            }
            <div className={styles.divider}/>
            {(slides && slides.length) &&
            <div className={styles.navigationBlock}>
              {slides.map((item, index) => (
                <span key={index} onClick={() => click(index)}
                      style={selected === index ? { backgroundColor: '#ff9800' } : null}
                      className={styles.navigationPoint}/>
              ))}
            </div>
            }
          </div>
          <div className={styles.description} style={{ color: color }}>
            <div
              dangerouslySetInnerHTML={{
                __html: `<span>${description}</span>`
              }}
            />
            {detailsText && <DetailsBtn text={detailsText} path={detailsPath}/>}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default CarouselItem;
